module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cobertura"
    }
  }, [_c('div', {
    staticClass: "col-md-12 flecha-container"
  }, [_c('h1', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_vm._v("COBERTURA")]), _vm._v(" "), _c('img', {
    staticClass: "flecha",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1500",
      "src": require("imgs/icons/Flecha_Negra.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "map-container",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    attrs: {
      "src": require("imgs/mapa.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "floating-redbox",
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "data-aos": "zoom-in",
      "data-aos-duration": "1500"
    }
  }, [_vm._v("\n En A&A buscamos brindar una amplia cobertura en territorio, abarcando estados como: California, Oregón, Arizona y Texas. Nos hemos convertido en un corporativo logístico de importancia, altamente confiable, dispuesto a servir a aquellas empresas que depositan su confianza en nuestras manos. \n\n")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f05f34e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cobertura.vue
// module id = 75
// module chunks = 0